// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer-links-module--wrapper--287ei","ul":"footer-links-module--ul--A_kU4","glow":"footer-links-module--glow--2jCI2"};